/**
 * Blog Tag Filter
 * Dynamically loads blog articles by tag without page reload
 */

class BlogFilter extends HTMLElement {
  connectedCallback() {
    this.form =
      this.querySelector('[data-search-form]') ||
      this.closest('[role="search"]');

    const tagLinks = this.querySelectorAll('[data-blog-tag]');

    tagLinks.forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const tag = link.getAttribute('data-blog-tag');
        this.filterByTag(tag, link.href);
      });
    });
  }

  filterByTag(tag, tagUrl) {
    const container = document.querySelector('[data-blog-container]');
    if (!container) return;

    const filterUrl = new URL(tagUrl, window.location.origin);
    const requestUrl = new URL(filterUrl.toString());
    requestUrl.searchParams.set('section_id', 'blog');

    // Mark as loading
    container.style.opacity = '0.6';

    // Fetch the filtered page
    fetch(requestUrl.toString())
      .then((response) => response.text())
      .then((html) => {
        // Parse the response and extract the new grid
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[data-blog-grid]');
        const newPagination = doc.querySelector('[data-blog-pagination]');

        if (newGrid) {
          const currentGrid = document.querySelector('[data-blog-grid]');
          if (currentGrid) {
            currentGrid.innerHTML = newGrid.innerHTML;
          }
        }

        if (newPagination) {
          const currentPagination = document.querySelector(
            '[data-blog-pagination]',
          );
          if (currentPagination) {
            currentPagination.innerHTML = newPagination.innerHTML;
            currentPagination.style.display = 'block';
          }
        } else {
          const currentPagination = document.querySelector(
            '[data-blog-pagination]',
          );
          if (currentPagination) {
            currentPagination.innerHTML = '';
            currentPagination.style.display = 'none';
          }
        }

        // Update active tag link state
        document.querySelectorAll('[data-blog-tag]').forEach((control) => {
          control.classList.remove('active');
          control.removeAttribute('aria-current');
        });
        document
          .querySelector(`[data-blog-tag="${tag}"]`)
          ?.classList.add('active');
        document
          .querySelector(`[data-blog-tag="${tag}"]`)
          ?.setAttribute('aria-current', 'page');

        // Update URL
        window.history.pushState(
          null,
          '',
          `${filterUrl.pathname}${filterUrl.search}`,
        );

        // Restore opacity
        container.style.opacity = '1';
      })
      .catch((error) => {
        console.error('Error loading filtered blog:', error);
        container.style.opacity = '1';
      });
  }
}

customElements.define('blog-filter', BlogFilter);
